module.exports = __webpack_public_path__ + "img/6883fd5.png";